import { Reveal } from "./Reveal";
import { MANIFESTO } from "../../data/site";

export default function Manifesto() {
  return (
    <section id="valores" data-testid="manifesto-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="mb-20 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-coral">
            / Nossos valores
          </span>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Segurança técnica.<br />Segurança jurídica.
          </h2>
        </Reveal>

        <div className="border-t border-white/10">
          {MANIFESTO.map((m, i) => (
            <Reveal
              key={m.n}
              delay={i * 0.08}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 border-b border-white/10 py-12 md:py-16 transition-colors duration-500 hover:bg-surface/40"
            >
              <div className="md:col-span-2">
                <span className="font-mono text-coral text-sm">{m.n}</span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display font-extrabold tracking-tight text-white text-4xl sm:text-5xl group-hover:translate-x-2 transition-transform duration-500">
                  {m.title}
                </h3>
              </div>
              <div className="md:col-span-6">
                <p className="text-muted-fg text-lg leading-relaxed max-w-xl">{m.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
